import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { throwError } from 'rxjs';

@Injectable()
export class ContractorManagerService {

  constructor(private http: HttpClient) { }

  public getAllContractorManagers(pagination, sort) {

    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    const sortString = '&sort=' + sort;

    return this.http.get(environment.apiUrl + 'api/ext-skylark-user/maintenance-manager-user' + paginationString + sortString, { observe: 'response' })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  public getAllContractorManagersNoPagination() {
    return this.http.get(environment.apiUrl + 'api/ext-skylark-user/maintenance-manager-user?size=10000&page=0')
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public createContractorManager(obj) {
    return this.http.post(environment.apiUrl + 'api/ext-skylark-user/maintenance-manager-user-create', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public editContractorManager(obj) {
    return this.http.put(environment.apiUrl + 'api/ext-skylark-user/maintenance-manager-user-update', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public updateContractorManagerPassword(obj) {
    return this.http.put(environment.apiUrl + 'api/ext-skylark-user/update-password', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Handle Responses
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      'headers': headers,
      'body': body
    };
    return data;
  }


  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }

}
